export default __webpack_public_path__ + "static/media/social-fb-icon.6f4a3f2b.svg";